import { Select } from '@/ui'

interface Props {
  label: string
  value: string | null
  sheets: Array<{ id: string; name: string; type: string }>
  onChange: (id: string | null) => void
}

/** 전역 CSS/JS 시트 셀렉트 — '없음'(value='') 옵션 포함. */
export function GlobalSheetSelect({ label, value, sheets, onChange }: Props) {
  const options = [
    { value: '', label: '없음' },
    ...sheets.map((s) => ({ value: s.id, label: `${s.name} (${s.type})` })),
  ]
  return (
    <Select
      label={label}
      options={options}
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value === '' ? null : e.target.value)}
    />
  )
}
